// extracted by mini-css-extract-plugin
export default {"tagContainer":"ZVk4B","premiumImage":"_2gBEX","superDealerImage":"dTjPx"};